<template>
	<div class="unauthorized">
		No autorizado
	</div>
</template>

<script>
	export default {
		name: 'Unauthorized',
	}
</script>
